import { render, staticRenderFns } from "./DirectViewer.vue?vue&type=template&id=c8142354&scoped=true&"
import script from "./DirectViewer.vue?vue&type=script&lang=js&"
export * from "./DirectViewer.vue?vue&type=script&lang=js&"
import style0 from "./DirectViewer.vue?vue&type=style&index=0&id=c8142354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8142354",
  null
  
)

export default component.exports